import React, { useState } from 'react';
import { StyledAvatar } from './StyledAvatar';
import { getProfileCredentials } from 'src/utils/auth';
import { useAuth } from 'src/state/auth/auth';
import { UserModal } from 'src/components/modals/UserModal';
import { useCache } from 'src/graphql/useCache';
import { mpEvent, MPEvents, Tags } from 'src/utils/mixpanel';
import * as S from './TableUserItem.styles';

interface TableUserItemProps {
  profilePhotoPath?: string | null;
  name?: string | null;
  interactive?: {
    onClick?: () => void;
    email?: string | null;
    scope: 'workspace' | 'organisation';
    workspaceId?: string;
    orgId?: string;
  };
}

export const TableUserItem: React.FC<TableUserItemProps> = ({ profilePhotoPath, name, interactive }) => {
  const { workspaceId, orgId } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hasEmail = !!interactive?.email;
  const { refetchQuery } = useCache();

  return (
    <>
      {isModalOpen && interactive?.email && (
        <UserModal
          onClose={() => setIsModalOpen(false)}
          userEmail={interactive.email}
          onUserUpdated={() =>
            refetchQuery({
              include:
                interactive.scope === 'workspace'
                  ? ['workspace', 'workspaceMembers']
                  : ['organisation'],
            })
          }
          workspaceId={interactive?.scope === 'workspace' ? interactive.workspaceId || workspaceId : undefined}
          orgId={interactive?.scope === 'organisation' ? interactive.orgId || orgId : undefined}
        />
      )}
      <S.AvatarWrapper
        onClick={() => {
          interactive?.onClick?.();
          if (hasEmail) {
            setIsModalOpen(true);
            mpEvent(MPEvents.ButtonClick, {
              button: '[user click]',
              value: interactive.email,
              tags: [interactive?.scope?.toUpperCase(), 'USER'].filter(Boolean) as Tags[],
            });
          }
        }}
        $cursorPointer={hasEmail}
      >
        <StyledAvatar src={profilePhotoPath || ''}>{getProfileCredentials(name || '')}</StyledAvatar>
        <span className={`elipsis ${hasEmail ? 'table-link' : ''}`}>{name}</span>
      </S.AvatarWrapper>
    </>
  );
};

interface PlainUserLinkProps {
  email: string;
  name?: string | null | number;
}
export const PlainUserLink = ({ email, name }: PlainUserLinkProps) => {
  const { workspaceId } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const { refetchQuery } = useCache();

  return (
    <span onClick={(e) => e.stopPropagation()}>
      {isOpen && (
        <UserModal
          onClose={() => setIsOpen(false)}
          userEmail={email}
          onUserUpdated={() => refetchQuery({ include: ['workspace', 'workspaceMembers'] })}
          workspaceId={workspaceId}
        />
      )}
      {email ? (
        <span
          className="table-link"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
        >
          {name}
        </span>
      ) : (
        <span>{name}</span>
      )}
    </span>
  );
};
